import { FC } from 'react';
import { BookitupNotification } from '../../../../Types/LogT';
import { Text } from '@mantine/core';

const TaskDeleted: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { value } = notification;
  return (
    <Text>
      Aufgabe{' '}
      <Text span weight="bolder">
        {value}
      </Text>{' '}
      wurde gelöscht.
    </Text>
  );
};

export default TaskDeleted;
